import { render, staticRenderFns } from "./UserGroupList.vue?vue&type=template&id=f603f01a&scoped=true&"
import script from "./UserGroupList.vue?vue&type=script&lang=js&"
export * from "./UserGroupList.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupList.vue?vue&type=style&index=0&id=f603f01a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f603f01a",
  null
  
)

export default component.exports